import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0312a68a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["oversea"];
var _hoisted_2 = {
  key: 0,
  class: "loading"
};
var _hoisted_3 = {
  class: "sleep-list"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "tag-container"
};
var _hoisted_6 = {
  class: "tag-top-text"
};
var _hoisted_7 = {
  class: "tag-value"
};
var _hoisted_8 = {
  class: "tag-bottom-text"
};
var _hoisted_9 = {
  class: "own-sleep-data-container"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "own-sleep-data"
};
var _hoisted_12 = {
  class: "sleep-data"
};
var _hoisted_13 = {
  class: "sleep-text"
};
var _hoisted_14 = {
  class: "other-sleep-data-container"
};
var _hoisted_15 = {
  class: "global-sleep-data-container"
};
var _hoisted_16 = ["src"];
var _hoisted_17 = {
  class: "global-sleep-data"
};
var _hoisted_18 = {
  class: "sleep-data"
};
var _hoisted_19 = {
  class: "sleep-text"
};
var _hoisted_20 = {
  class: "sleep-tips"
};
var _hoisted_21 = {
  class: "sleep-list"
};
var _hoisted_22 = {
  class: "title"
};
var _hoisted_23 = {
  class: "tag-container"
};
var _hoisted_24 = {
  class: "tag-top-text"
};
var _hoisted_25 = {
  class: "tag-value"
};
var _hoisted_26 = {
  class: "tag-bottom-text"
};
var _hoisted_27 = {
  class: "own-sleep-data-container"
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  class: "own-sleep-data"
};
var _hoisted_30 = {
  class: "sleep-data"
};
var _hoisted_31 = {
  class: "sleep-text"
};
var _hoisted_32 = {
  class: "other-sleep-data-container"
};
var _hoisted_33 = {
  class: "global-sleep-data-container"
};
var _hoisted_34 = ["src"];
var _hoisted_35 = {
  class: "global-sleep-data"
};
var _hoisted_36 = {
  class: "sleep-data"
};
var _hoisted_37 = {
  class: "sleep-text"
};
var _hoisted_38 = {
  class: "sleep-tips"
};
var _hoisted_39 = {
  class: "sleep-list"
};
var _hoisted_40 = {
  class: "title"
};
var _hoisted_41 = {
  class: "tag-container"
};
var _hoisted_42 = {
  class: "tag-top-text"
};
var _hoisted_43 = {
  class: "tag-value"
};
var _hoisted_44 = {
  class: "tag-bottom-text"
};
var _hoisted_45 = {
  class: "own-sleep-data-container"
};
var _hoisted_46 = ["src"];
var _hoisted_47 = {
  class: "own-sleep-data"
};
var _hoisted_48 = {
  class: "sleep-data"
};
var _hoisted_49 = {
  class: "sleep-text"
};
var _hoisted_50 = {
  class: "other-sleep-data-container"
};
var _hoisted_51 = {
  class: "global-sleep-data-container"
};
var _hoisted_52 = ["src"];
var _hoisted_53 = {
  class: "global-sleep-data"
};
var _hoisted_54 = {
  class: "sleep-data"
};
var _hoisted_55 = {
  class: "sleep-text"
};
var _hoisted_56 = {
  class: "sleep-tips"
};
var _hoisted_57 = {
  key: 0,
  class: "open-vip-box"
};
var _hoisted_58 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_loading = _resolveComponent("van-loading");

  var _component_no_net_tip = _resolveComponent("no-net-tip");

  return _openBlock(), _createElementBlock("div", {
    class: "sleep-data-compare",
    oversea: $data.oversea
  }, [$data.isloading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_loading, {
    size: "24",
    color: "#3F96F3"
  })])) : $data.noNet ? (_openBlock(), _createBlock(_component_no_net_tip, {
    key: 1
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", {
    class: _normalizeClass($data.flag === 1 ? 'sleep-lists' : 'sleep-lists unlock')
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t("message.sleep.sleepDuration")) + " ", 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass($data.detail.sleepTimePercent < 60 ? 'tag-text-container low' : 'tag-text-container')
  }, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("message.sleep.sleepQualityCompare1")), 1), _createElementVNode("span", _hoisted_7, _toDisplayString($data.detail.sleepTimePercent) + "%", 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("message.sleep.sleepQualityCompare3")), 1)], 2)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: $data.avatar,
    class: "left-img"
  }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.transferSeconds($data.detail.totalSleepTime)), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("message.sleep.sleepTimeText")), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
    src: $data.global_img,
    class: "left-img"
  }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString($data.flag === 1 ? $options.transferSeconds($data.detail.globalAvgSleepTime) : $data.sleepTime), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("message.sleep.avgGlobalSleepTime")), 1)])])]), _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("message.sleep.sleepTimeTip")), 1)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createTextVNode(_toDisplayString(_ctx.$t("message.sleep.bedTime")) + " ", 1), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: _normalizeClass($data.detail.startTimePercent < 60 ? 'tag-text-container low' : 'tag-text-container')
  }, [_createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("message.sleep.sleepQualityCompare1")), 1), _createElementVNode("span", _hoisted_25, _toDisplayString($data.detail.startTimePercent) + "%", 1), _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("message.sleep.sleepQualityCompare3")), 1)], 2)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    src: $data.avatar,
    class: "left-img"
  }, null, 8, _hoisted_28), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString($options.transferSecondsToTime($data.detail.startReal)), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("message.sleep.bedTimeText")), 1)])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("img", {
    src: $data.global_img,
    class: "left-img"
  }, null, 8, _hoisted_34), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString($data.flag === 1 ? $options.transferSecondsToTime($data.detail.globalAvgStartTime) : $data.sleepTime), 1), _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("message.sleep.avgGlobalBedTime")), 1)])])]), _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("message.sleep.bedTimeTip")), 1)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createTextVNode(_toDisplayString(_ctx.$t("message.sleep.getUpTime")) + " ", 1), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", {
    class: _normalizeClass($data.detail.endTimePercent < 60 ? 'tag-text-container low' : 'tag-text-container')
  }, [_createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("message.sleep.sleepQualityCompare1")), 1), _createElementVNode("span", _hoisted_43, _toDisplayString($data.detail.endTimePercent) + "%", 1), _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("message.sleep.sleepQualityCompare3")), 1)], 2)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("img", {
    src: $data.avatar,
    class: "left-img"
  }, null, 8, _hoisted_46), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString($options.transferSecondsToTime($data.detail.endReal)), 1), _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t("message.sleep.getUpTimeText")), 1)])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("img", {
    src: $data.global_img,
    class: "left-img"
  }, null, 8, _hoisted_52), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString($data.flag === 1 ? $options.transferSecondsToTime($data.detail.globalAvgEndTime) : $data.sleepTime), 1), _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("message.sleep.avgGlobalGetUpTime")), 1)])])]), _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("message.sleep.getUpTimeTip")), 1)])], 2), $data.flag != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_createElementVNode("div", {
    class: "btn",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.goOpenVipPage();
    })
  }, [_createElementVNode("img", {
    src: $data.imgVip,
    alt: ""
  }, null, 8, _hoisted_58), _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.sleep.openVipToSee")), 1)])])) : _createCommentVNode("", true)], 64))], 8, _hoisted_1);
}